import { render, staticRenderFns } from "./OCSCustomerShippingmark.vue?vue&type=template&id=54969d2f&scoped=true&"
import script from "./OCSCustomerShippingmark.vue?vue&type=script&lang=js&"
export * from "./OCSCustomerShippingmark.vue?vue&type=script&lang=js&"
import style0 from "./OCSCustomerShippingmark.vue?vue&type=style&index=0&id=54969d2f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54969d2f",
  null
  
)

export default component.exports